const go = (state, action) => {
	state.navigation.type = action?.payload?.type ?? null;
};

export { go as navigationGo };
